import { createRouter, createWebHistory } from "vue-router";
import Viewer from "../views/Viewer.vue";

const routes = [
  {
    path: "/:token",
    component: Viewer,
  },
  {
    path: "/",
    component: Viewer,
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
